function STPReports() {
  return (
    <div>
      <div style={{ width: "100%", height: "100%" }}>
        <iframe
          src="/STPRTP.htm" // your HTML file in public folder
          title="STP Reports"
          width="100%"
          height="900px"
          style={{ border: "none" }}
        />
      </div>
    </div>
  );
}

export default STPReports;
